// 10/5/2016 -- Generated by hand from PortCall.Models\Users\PCRoles.cs.

export enum PCRoles {
    SiteAdmin     = 10,
    ManageBerths  = 20,
    ManageUsers   = 30,
    ReserveBerths = 40,
    ManageBills   = 50
}


// WEBPACK FOOTER //
// ./data/models/PCRoles.ts